import React from "react";
import "@/components/notifications/notificationsList.scss";

const NotificationList = ({ allPushNotificaions, handleNotificationClick }) => {
  return (
    <div className="notification-list">
      {allPushNotificaions.map((item) => {
        // Parse the timestamp and format it
        const date = new Date(item.createdAt);
        const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        const formattedDate = date.toLocaleDateString(); // Format it as needed

        return (
          <div
            key={item.id}
            className={`notification-item ${item.read ? "read" : "unread"}`}
            onClick={() => handleNotificationClick(item)}
          >
            <div className="notification-left">
              <img src={item.image || "/assets/images/square-logo.png"} alt="Notification Icon" />
            </div>
            <div className="notification-right">
              <div className="notification-message">{item.message}</div>
              <div className="notification-time">
                {time} • {formattedDate}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationList;
